import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

import SidebarContainer from '../SidebarContainer';
import sourceMappingsActions from '../../redux/sourceMappings/actions';
import ErrorMessage from '../../components/ErrorMessage';
import './SourceMapping.scss';

import {
  SourceMappingEditor,
  NewSourceMapping,
} from '../../components/SourceMappingEditor';
import DealerNav from '../../components/DealerNav';

class SourceMapping extends Component {
  componentDidMount() {
    const { dealerId } = this.props.match.params;
    const { dealer } = this.props;
    if (dealerId) {
      this.props.actions.sourceMappingRequest(dealerId);
    } else {
      this.props.actions.resetSourceMapping(dealer.id);
    }
  }

  onCreate = (params) => {
    this.props.actions.createSourceMappingRequest(params);
  };

  onSave = (sourceMapping) => {
    this.props.actions.updateSourceMappingRequest(sourceMapping);
  };

  render() {
    const { sourceMappings, dealer } = this.props;
    const { sourceMapping, error, fetching } = sourceMappings;

    return (
      <SidebarContainer title={dealer.name} logo={dealer.logo}>
        <div className="source-mappings-table">
          <DealerNav />
          {error && <ErrorMessage error={error} />}
          {sourceMapping.id && (
            <SourceMappingEditor
              sourceMapping={sourceMapping}
              fetching={fetching}
              onSave={this.onSave}
            />
          )}
          {!sourceMapping.id && (
            <NewSourceMapping
              sourceMapping={sourceMapping}
              fetching={fetching}
              onCreate={this.onCreate}
            />
          )}
        </div>
      </SidebarContainer>
    );
  }
}

SourceMapping.propTypes = {
  match: PropTypes.object,
  sourceMappings: PropTypes.object,
  dealer: PropTypes.object,
  actions: PropTypes.object,
};

const mapStateToProps = ({ sourceMappings, dealers }) => ({
  sourceMappings,
  dealer: dealers.dealer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(sourceMappingsActions, dispatch),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SourceMapping),
);
